// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Button from "@insite/mobius/Button";
import { useToaster } from "@insite/mobius/Toast/ToasterContext";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import React, { FC } from "react";
import { css } from "styled-components";

const StyleguideToasts: FC = () => {
    const toaster = useToaster();
    const body = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elementum maximus neque ut pretium.";

    const wrapperCss = css`
        display: flex;
        gap: 10px;
        flex-flow: row wrap;
        flex: 1 0 100%;
    `;

    return (
        <StyleguideSection title="Toasts">
            <StyledWrapper css={wrapperCss}>
                <Button onClick={() => toaster.addToast({ body, messageType: "info" })}>Info</Button>
                <Button onClick={() => toaster.addToast({ body, messageType: "warning" })}>Warning</Button>
                <Button onClick={() => toaster.addToast({ body, messageType: "danger" })}>Error</Button>
                <Button onClick={() => toaster.addToast({ body, messageType: "success" })}>Success</Button>
            </StyledWrapper>
        </StyleguideSection>
    );
};

export default StyleguideToasts;
